import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import UseCaseDetailsFrame from 'src/components/use-case-details-frame'
import PillButton from 'src/components/pill-button'
import TextButton from 'src/components/text-button'
import TapAnimation from 'src/components/tap-animation'
import PhoneContainer from 'src/components/phone-container'
import content1Src from 'src/assets/use-case-6-content-1.png'
import content2SrcA from 'src/assets/use-case-6-content-2-a.png'
import content2SrcB from 'src/assets/use-case-6-content-2-b.png'
import content3SrcA from 'src/assets/use-case-6-content-3-a.png'
import content3SrcB from 'src/assets/use-case-6-content-3-b.png'

export class UseCase6Frame1 extends Component {
  static propTypes = {
    className: PropTypes.string,
    useCase: PropTypes.object.isRequired,
    back: PropTypes.func.isRequired,
    tapDelay: PropTypes.number,
  }

  static defaultProps = {
    className: '',
    tapDelay: 500,
  }

  state = {
    contentId: 'content-1',
    shouldTap1: false,
    onTapComplete: () => {},
  }

  get className() {
    const { className } = this.props
    return c('im-use-case-6-frame-1', className)
  }

  render() {
    const { className } = this
    const { useCase, back, tapDelay } = this.props
    const { contentId, shouldTap1, onTapComplete } = this.state
    const { content1, content2, content3 } = useCase
    return (
      <UseCaseDetailsFrame className={className} back={back} useCase={useCase}>
        <section className={c('content content-1', contentId === 'content-1' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h3>{content1.copy1}</h3>
              <h2>{content1.copy2}</h2>
            </section>
            <section className="pill-buttons">
              <PillButton
                onClick={() => {
                  this.setState({ forceIndex: 0 })
                  setTimeout(() => {
                    this.setState({
                      shouldTap1: true,
                      onTapComplete: () => {
                        this.setState({ contentId: 'content-2', shouldTap1: false })
                      },
                    })
                  }, tapDelay)
                }}>
                {content1.button1}
              </PillButton>
              <PillButton
                onClick={() => {
                  this.setState({ forceIndex: 0 })
                  setTimeout(() => {
                    this.setState({
                      shouldTap1: true,
                      onTapComplete: () => {
                        this.setState({ contentId: 'content-3', shouldTap1: false })
                      },
                    })
                  }, tapDelay)
                }}>
                {content1.button2}
              </PillButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer src={content1Src}>
              <TapAnimation className="tap-1" shouldTap={shouldTap1} onTapComplete={onTapComplete} />
            </PhoneContainer>
          </section>
        </section>
        <section className={c('content content-2', contentId === 'content-2' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content2.copy1}</h2>
              <p>{content2.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content2.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer showBackground={true} src={[content2SrcA, content2SrcB]} />
          </section>
        </section>
        <section className={c('content content-3', contentId === 'content-3' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content3.copy1}</h2>
              <p>{content3.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content3.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer showBackground={true} src={[content3SrcA, content3SrcB]} />
          </section>
        </section>
      </UseCaseDetailsFrame>
    )
  }
}

export default UseCase6Frame1
